import React, { useState } from "react";
import { Card, Button, Dropdown } from "react-bootstrap";
import { FiCalendar, FiPlus } from "react-icons/fi";
import { BsGrid3X3GapFill } from "react-icons/bs";
import AddTodoModal from "../../modals/admin-dashboard/AddTodoModal";
// import InsertImageModal from "../../modals/admin-dashboard/AddTodoModal";

export default function Todo() {
  const [showModal, setShowModal] = useState(false);
  const [filter, setFilter] = useState("today");

  const [todos, setTodos] = useState([
    { title: "Add Holidays", bg: "#ffffff", date: "today" },
    { title: "Add Meeting to Client", bg: "#f3e1d7", date: "today" },
    { title: "Chat with Adrian", bg: "#e8bcbc", date: "today" },
    { title: "Management Call", bg: "#dccae4", date: "today" },
    { title: "Add Payroll", bg: "#c9d8ea", date: "today" },
    { title: "Add Policy for Increment", bg: "#efe0b7", date: "today" },
  ]);

  const addTodo = (data) => {
    setTodos([...todos, data]);
    setShowModal(false);
  };

  const filtered = todos.filter((t) => t.date === filter);

  return (
    <>
      <Card className="todo-card task-card h-100">
        <Card.Header className="todo-header card-header-custom">
          <h5>Todo</h5>

          <div className="todo-actions ">
            <Dropdown>
              <Dropdown.Toggle className="date-btn text-dark">
                <FiCalendar className="pb-1" />{" "}
                {filter === "today"
                  ? "Today"
                  : filter === "week"
                    ? "This Week"
                    : "This Month"}
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item onClick={() => setFilter("today")}>
                  Today
                </Dropdown.Item>
                <Dropdown.Item onClick={() => setFilter("week")}>
                  This Week
                </Dropdown.Item>
                <Dropdown.Item onClick={() => setFilter("month")}>
                  This Month
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>

            <Button className="add-btn" onClick={() => setShowModal(true)}>
              <FiPlus className="text-white" />
            </Button>
          </div>
        </Card.Header>

        <Card.Body>
          {filtered.map((todo, i) => (
            <div key={i} className="todo-item" style={{ background: todo.bg }}>
              <BsGrid3X3GapFill className="dots" />

              <input type="checkbox" />

              <span>{todo.title}</span>
            </div>
          ))}
        </Card.Body>
      </Card>

      <AddTodoModal
        show={showModal}
        handleClose={() => setShowModal(false)}
        addTodo={addTodo}
      />

      <style>{`

.todo-card{
border-radius:6px;
border:1px solid #e5e7eb;
background:#ffffff;

box-shadow:0 2px 5px rgba(0,0,0,0.05);;
}

      .card-header-custom{
display:flex;
justify-content:space-between;
align-items:center;
padding:18px;
border-bottom:1px solid #eee;
background:#ffffff;


}

.card-header-custom h5{
margin:0;
font-size:18px;
font-weight:600;
color:#1f2937;
}
.todo-header{
display:flex;
justify-content:space-between;
align-items:center;
padding:16px;
border-bottom:1px solid #eee;
}

.todo-header h5{
font-weight:600;
margin:0;
}

.todo-actions{
display:flex;
align-items:center;
gap:10px;
}

.date-btn{
background:#fff;
border:1px solid #ddd;
font-size:14px;
}

.add-btn{
width:34px;
height:34px;
border-radius:50%;
display:flex;
align-items:center;
justify-content:center;
background:#ff6a00;
border:none;
}

.todo-item{
display:flex;
align-items:center;
gap:10px;
padding:7px;
border-radius:6px;
border:1px solid #eee;
margin-bottom:12px;
}

.dots{
color:#666;
}
.dropdown-toggle::after {
  display: none !important; }
  @media (max-width:576px){
.task-card{
margin-top:15px;
}
}

@media (max-width:992px){
.task-card{
margin-top:15px;
}
}

@media (max-width:1024px){
.task-card{
margin-top:15px;
}
}
`}</style>
    </>
  );
}
